export default __webpack_public_path__ + "static/media/insta.b109c802.svg";